import { useMutation } from '@apollo/client';
import { RestoreOrgUserDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { evictField } from '@/utils/graphqlUtils';

/**
 * Apollo (legacy) implementation of restore — used when the `trpc`
 * feature flag is off. Calls the `restore_org_user` Hasura action.
 *
 * Refetch by operation name so the active observable matches regardless
 * of variables (see useArchiveUserGraphQL comment).
 */
export const useRestoreUserGraphQL = () => {
  const [mutate, state] = useMutation(RestoreOrgUserDocument, {
    refetchQueries: ['GetAuthUsers'],
    awaitRefetchQueries: true,
    update: (cache) => {
      evictField(cache, 'auth_user');
      evictField(cache, 'auth_user_aggregate');
    },
  });

  return {
    restoreUser: async (userId: string) => {
      const result = await mutate({ variables: { userId } });
      if (!result.data?.restore_org_user) {
        throw new Error('Restore user mutation returned no data');
      }

      return result.data.restore_org_user;
    },
    loading: state.loading,
    error: state.error,
  };
};
